import { HowWorksSectionProps } from "@models/blocks/how-it-works.interface";
import { IStartIntegrationSection } from "@models/blocks/start-integration.interface";
import { IMetaData } from "@models/meta-data.interface";

export interface IProductDetailPage {
  title: string;
  metaData: IMetaData;
  previewSection: IPreviewSection;
  trustedBySection: ITrustedBySection;
  cryptoBenefitsSection: ICryptoBenefitsSection;
  howWorksSection: HowWorksSectionProps;
  startIntegrationSection?: IStartIntegrationSection;
}

export interface IPreviewSection {
  title: [string, string];
  subtitle: string;
  buttonText: string;
  imgUrl: string;
}

export interface IPreviewSubtitleCard {
  title: string;
  subtitle: string;
}

export interface ITrustedBySection {
  title: string;
  cards: string[];
}

export interface ICryptoBenefitsSection {
  title: string;
  cards: ICryptoBenefitsCard[];
}

export interface ICryptoBenefitsCard {
  title: string;
  subtitle: string;
  icon: string;
  link: string;
  linkText: string;
}

export enum ProductSlug {
  ON_RAMP = 'on-ramp',
  OFF_RAMP = 'off-ramp',
  CORPORATE_ON_OFF_RAMP = 'corporate-on-off-ramp',
  ACCEPT_CRYPTO = 'accept-crypto',
  ACCEPT_PAYMENTS = 'accept-payments',
  POS = 'pos',
  CRYPTO_PAYROLL = 'crypto-payroll',
}
